import { ActivityCard } from '../../core/domain/activity-card';

export class ActivityCardFactory {
  static bjjGi(): ActivityCard {
    return {
      title: 'BJJ GI',
      image: 'bjj_gi_1.jpg',
      warmup: 10,
      technic: 20,
      sparring: 30,
      content:
        'Gi ist die traditionelle Uniform des BJJ. Gerade für Anfänger ist es einfacher mit dem Gi zu starten, da es mehr Griffmöglichkeiten bietet als beim No-Gi und so den Einstieg erleichtert.',
      backgroundColor: 'bjj-gi',
    } as ActivityCard;
  }

  static bjjNoGi(): ActivityCard {
    return {
      title: 'BJJ NO-GI',
      image: 'bjj_no_gi_1.jpeg',
      warmup: 15,
      technic: 30,
      sparring: 15,
      content:
        'No-Gi ist die Variante des Brazilian Jiu-Jitsu bei der man ohne den traditionellen Gi (Uniform) trainiert. Man trägt bequemere Kleidung wie zum Beispiel ein Shirt oder ein Rushguard.',
      backgroundColor: 'bjj-no-gi',
    } as ActivityCard;
  }

  static bjjKids(): ActivityCard {
    return {
      title: 'BJJ Kids',
      image: 'bjj_kids_1.jpg',
      warmup: 15,
      technic: 30,
      sparring: 15,
      content:
        'BJJ für Kids bedeutet Selbstverteidigung, Training, Körperbeherrschung und Spass in einem. Eltern haben die Möglichkeit parallel zum Kindertraining ebenfalls zu trainieren.',
      backgroundColor: 'bjj-kids',
    } as ActivityCard;
  }

  static bjjWomen(): ActivityCard {
    return {
      title: 'BJJ Women',
      image: 'bjj_women_1.jpg',
      warmup: 15,
      technic: 30,
      sparring: 15,
      content:
        'BJJ ist sehr effektiv gegen grössere, stärkere und schwerere Gegner. Das macht es zu einer idealen Sportart für Frauen. Durch Fitness und Selbstverteidigung zu mehr Selbstsicherheit.',
      backgroundColor: 'bjj-women',
    } as ActivityCard;
  }

  static bjjDrills(): ActivityCard {
    return {
      title: 'BJJ Drills',
      image: 'bjj_drills_1.jpg',
      drills: 45,
      stretching: 15,
      content:
        'Bei Drills geht es darum Grundtechniken zu perfektionieren, in dem man sie in einer schnellen Abfolge ständig wiederholt. Die hohe Intensität verbessert auch die Ausdauer.',
      backgroundColor: 'bjj-drills',
      textColor: 'white',
    } as ActivityCard;
  }

  static bjjSparring(): ActivityCard {
    return {
      title: 'BJJ Sparring',
      image: 'bjj_sparring_1.jpg',
      warmup: 10,
      sparring: 50,
      content:
        'BJJ ist sehr anwendungsorientiert. Beim Sparring werden die gelernten Techniken im Kampf eingesetzt. Die Schwierigkeit besteht darin, zu entscheiden welche Technik wann und wie genutzt werden kann.',
      backgroundColor: 'bjj-sparring',
      textColor: 'white',
    } as ActivityCard;
  }

  static openMat(): ActivityCard {
    return {
      title: 'Open Mat',
      image: 'bjj_openmat_2.jpg',
      sparring: 60,
      content: 'Open Mat intern: Free roll für die internen Schüler, kein geführtes Training.\n\n' + 'Open mat: Free roll für alle - your Friends are welcome',
      backgroundColor: 'open-mat',
      textColor: 'white',
    } as ActivityCard;
  }
}
